import React from 'react';
import { Box, Typography, Fade } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

export const SaveSuccess = ({ show, message = 'Saved successfully' }) => {
  return (
    <Fade in={show}>
      <Box
        sx={{
          position: 'fixed',
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          bgcolor: 'success.main',
          color: 'success.contrastText',
          py: 1,
          px: 2,
          borderRadius: 2,
          boxShadow: theme => `0 4px 20px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.15)'}`,
        }}
      >
        <CheckIcon sx={{ fontSize: 20 }} />
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {message}
        </Typography>
      </Box>
    </Fade>
  );
}; 